import React, { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "../../ui/dropdown-menu";
import { exportResource } from "../../../lib/exportApi";
import { cn } from "lib/utils";

const FORMAT_OPTIONS = [
  { value: "csv", label: "Export as CSV" },
  { value: "xlsx", label: "Export as Excel" },
];

const ExportMenu = ({
  resource,
  params = {},
  label = "Export",
  className = "btn btn-primary",
  disabled = false,
  align = "end",
  contentClassName,
  leftIcon,
  rightAdornment,
  title,
}) => {
  const [exporting, setExporting] = useState(false);

  const handleExport = async (format) => {
    if (exporting) return;
    setExporting(true);
    try {
      await exportResource(resource, params, format);
    } finally {
      setExporting(false);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className={className}
          disabled={disabled || exporting}
          title={title}
        >
          {leftIcon}
          {exporting ? "Exporting…" : label}
          <span aria-hidden="true" style={{ marginLeft: 6 }}>▾</span>
          {rightAdornment}
        </button>
      </DropdownMenuTrigger>
      {/* z-index above Bootstrap modals (~1055) so the menu is usable inside modal-based export flows. */}
      <DropdownMenuContent align={align} className={cn(contentClassName)}>
        {FORMAT_OPTIONS.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onSelect={() => handleExport(option.value)}
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExportMenu;
